(function () {
    let DOM_splash;
    let DOM_body = document.body;

    const { device_is_smartphone } = require('../util');

    window.addEventListener('DOMContentLoaded', function (event) {

        let selector_splash = '#splash';

        let ary_selector_animation_class=[
            `${selector_splash} [data-scene-name='first']`,
            `${selector_splash} [data-scene-name='second']`,
            `${selector_splash} [data-scene-name='third']`,
        ];

        DOM_splash = document.querySelector(selector_splash);


        if(device_is_smartphone()){
            if(DOM_splash){
                DOM_splash.classList.add('hide');
                DOM_body.classList.remove('scrollLocked');
                return;
            }
        }
        
        let animation_index=0;
        let DOM_first_scene;

        if(DOM_splash){
            DOM_splash.style.height=`${window.innerHeight}px`;
        } else {
            return;
        }

        for(selector_animation_class of ary_selector_animation_class){
            let DOM_temp = document.querySelector(selector_animation_class);
            if(DOM_temp === null){
                console.log(`freespace-slideanimation: [warning] DOM query failed: ${selector_animation_class}`);
                continue;
            }
            
            const switchNext = (index,e)=>{

                

                if(e.animationName != 'dummy') return;
                console.log(e);

                let selector_current;
                let selector_next;
                let next_index;
                selector_current = ary_selector_animation_class[index];
                next_index = (index+1)%(ary_selector_animation_class.length);
                selector_next = ary_selector_animation_class[next_index];
                
                DOM_current = document.querySelector(selector_current);
                DOM_next = document.querySelector(selector_next);

                DOM_current.removeEventListener('animationend',switchNext);

                DOM_current.classList.add("hide");
                DOM_current.classList.remove('animate');

                if(next_index != 0){
                    DOM_next.classList.add('animate');
                } else {
                    DOM_splash=document.querySelector(selector_splash);
                    if(DOM_splash){

                        DOM_splash.classList.add('hide');
                        DOM_body.classList.remove('scrollLocked');
                    }
                }
            };

            DOM_temp.addEventListener('animationend',switchNext.bind(null,animation_index));
            animation_index++;
        }
        
        DOM_first_scene = document.querySelector(ary_selector_animation_class[0]);
        if(DOM_first_scene === null){
            console.log(`splash:[warning] first scene (selector:${ary_selector_animation_class[0]} not found)`);
        } else {
            DOM_first_scene.classList.add('animate');
        }
    });
})();
